import { goToMenuViaSlug } from './locations';
import { editCart } from 'bento-ordering/cart/actions';
import { clearCart } from 'bento-ordering/cart/actions/index';
import { resetIsCartItemAvailable } from 'bento-ordering/cart/actions/cartAvailable';
import { getOnlineOrderingUrlParams } from 'bento-ordering/utils/url';
import { closeModal } from 'bento-ordering/base/actions/modal';

const setCartFulfillmentOptions = () => async (dispatch, getState) => {
  const state = getState();
  const { cartWorkingCopy, cartAvailable, router } = state;
  const {
    fulfillment_date,
    fulfillment_time,
    online_ordering_fulfillment_method,
    online_ordering_location,
    requested_fulfillment_is_asap,
    shipping_city,
    shipping_country,
    shipping_google_place_id,
    shipping_postal_code,
    shipping_state,
    shipping_street_address_1,
    shipping_street_address_2,
    shipping_lat,
    shipping_lng
  } = cartWorkingCopy;

  const fulfillmentOptions = {
    fulfillment_date,
    fulfillment_time,
    online_ordering_fulfillment_method,
    online_ordering_location,
    requested_fulfillment_is_asap,
    shipping_city,
    shipping_country,
    shipping_google_place_id,
    shipping_postal_code,
    shipping_state,
    shipping_street_address_1,
    shipping_street_address_2,
    shipping_lat,
    shipping_lng
  };
  const { locationSlug } = getOnlineOrderingUrlParams(router.location.pathname);

  // if items already in the cart are no longer available after changes to fulfillment options,
  // we need to empty the cart
  if (!cartAvailable.isAvailable) {
    await dispatch(clearCart());
    dispatch(resetIsCartItemAvailable());
  }
  await dispatch(editCart(fulfillmentOptions));
  dispatch(goToMenuViaSlug(locationSlug));
  dispatch(closeModal());
};

export default setCartFulfillmentOptions;
